// Content for the Melano International portfolio site.
// NOTE: Homepage/About/Commons/legal copy is STATIC MOCK content. Only the
// Contact form is wired to the backend. Photography is licensed stock given a
// documentary black-and-white treatment (placeholders until exact files arrive).

export const brandLinks = { nava: "https://nava.vision" };

export const nav = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "In Common", to: "/commons" },
  { label: "Contact", to: "/contact" },
];

export const assets = {
  monogram: "/assets/melano/melano_wordmark.png",
};

// Shared image pool (all rendered in B&W via .bw)
const IMG = {
  rays: "https://images.unsplash.com/photo-1588406320565-9fa6d9901d1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxldGhlcmVhbCUyMGxpZ2h0JTIwcmF5c3xlbnwwfHx8fDE3OTAyNzM1MTl8MA&ixlib=rb-4.1.0&q=85",
  portrait: "https://images.unsplash.com/photo-1633872907288-626f275d845d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxzaWxob3VldHRlJTIwd2FybXxlbnwwfHx8fDE3OTAyNzM1NzZ8MA&ixlib=rb-4.1.0&q=85",
  stage: "https://images.unsplash.com/photo-1536183922588-166604504d5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxkcmFtYXRpYyUyMGRhcmslMjBhdG1vc3BoZXJlfGVufDB8fHx8MTc5MDI3MzUxOXww&ixlib=rb-4.1.0&q=85",
  orb: "https://images.unsplash.com/photo-1476900164809-ff19b8ae5968?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxjYW5kbGVsaXQlMjBtZWRpdGF0aW9ufGVufDB8fHx8MTc5MDI3MzU3Nnww&ixlib=rb-4.1.0&q=85",
  ritual: "https://images.unsplash.com/photo-1641667838410-b257ca266e38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxtaXN0eSUyMGRhcmslMjBmb3Jlc3R8ZW58MHx8fHwxNzkwMjczNTE5fDA&ixlib=rb-4.1.0&q=85",
  crown: "https://images.unsplash.com/photo-1597839219216-a773cb2473e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxtaXN0eSUyMGRhcmslMjBmb3Jlc3R8ZW58MHx8fHwxNzkwMjczNTE5fDA&ixlib=rb-4.1.0&q=85",
  hands: "https://images.pexels.com/photos/9355602/pexels-photo-9355602.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  mountains: "https://images.pexels.com/photos/19248218/pexels-photo-19248218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  hills: "https://images.pexels.com/photos/4316230/pexels-photo-4316230.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  sunset: "https://images.unsplash.com/photo-1532275948649-7d97f309ef16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxnb2xkZW4lMjBob3VyJTIwbW91bnRhaW5zfGVufDB8fHx8MTc5MDI3MzU0OHww&ixlib=rb-4.1.0&q=85",
  cosmos: "https://images.unsplash.com/photo-1488866022504-f2584929ca5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxjb3NtaWMlMjBuaWdodHxlbnwwfHx8fDE3OTAyNzM2MDV8MA&ixlib=rb-4.1.0&q=85",
  sunrise: "https://images.unsplash.com/photo-1786961610487-e28e742636a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxtaXN0eSUyMHZhbGxleSUyMHN1bnJpc2V8ZW58MHx8fHwxNzkwMjczNTQ4fDA&ixlib=rb-4.1.0&q=85",
};

export const home = {
  hero: {
    wordmark: "Melano International",
    small: "Melano International is an events and production company working at the intersection of human flourishing and technology.",
    title: "Cultivating Intergenerational Vision",
    cta: { label: "Restore your vision", target: "#thought-leadership" },
    bg: "/assets/melano/photos/p217.webp",
  },
  thoughtLeadership: {
    eyebrow: "Thought Leadership",
    quote: "Ancestors didn\u2019t just pass down trauma, they passed down vision too.",
    img: "/assets/melano/photos/p17.webp",
  },
  whatHappened: {
    eyebrow: "What Happened to Vision?",
    body: "From the 1980s, vision became a strategy, a slogan on the wall and a vision board.",
    purple: true,
  },
  inventory: {
    eyebrow: "Our Inventory",
    body: "Human flourishing became human potential, then optimization. Vision became a single-point and we stopped looking at the whole sky.",
    img: "/assets/melano/photos/p55.webp",
  },
  philosophy: {
    eyebrow: "Philosophy",
    title: "Timeless Vision",
    lead: "The result of cultivating Intergenerational Vision.",
    body: "Eight ways of restoring vision beyond individual achievement and beyond one lifetime.",
    img: "/assets/melano/photos/p46.webp",
  },
  whyWeNeed: {
    eyebrow: "Why We Need It",
    body: "So we can Anchor Humanity and create a future worth inheriting.",
    img: "/assets/melano/photos/cx1524.jpg",
  },
  whatWeDo: {
    eyebrow: "What We Do",
    body: "We restore vision by looking up at the whole sky.",
    img: "/assets/melano/photos/pmel13.webp",
  },
  landLineage: {
    eyebrow: "Land & Lineage",
    heading: "Rooted in land. Guided by lineage.",
    headingLines: ["Rooted in land.", "Guided by lineage."],
    body: "Melano International is a home for work that returns us to what endures, the ground beneath us, the ancestors behind us, and the future we are here to serve.",
    bg: "/assets/melano/photos/img6483.webp",
  },
  ecosystem: {
    eyebrow: "The ways we bring it to life",
    heading: "Our Brands",
    note: "Four distinct brands, one shared vision. Each is a doorway into the wider work.",
    brands: [
      { id: "nava", name: "NAVA Vision\u2122", icon: "/assets/melano/nava_vision.png", caption: "Thought Leadership & Events", link: "https://nava.vision" },
      { id: "constellating-life", name: "Constellating Life\u2122", icon: "/assets/melano/eco_constellating_life.png", caption: "Constellation Event and Training Directory", link: null },
      { id: "dancing-zen", name: "Dancing Zen\u2122", icon: "/assets/melano/dancing_zen.png", caption: "Care & contribution, exchanged differently", link: null },
      { id: "constellate-88", name: "Constellate 88", icon: "/assets/melano/eco_constellate_88.png", caption: "Interactive card and AI experience", link: null },
    ],
  },
  quote: {
    text: "A Timeless Vision is steady when everything changes.",
    caption: "The orientation that shapes the company and every brand within it.",
    bg: "/assets/melano/photos/p50.webp",
  },
  workWith: {
    eyebrow: "Who Do We Work With?",
    body: "Visionaries, Futurists and those restoring relationships with what came before.",
    bg: "/assets/melano/photos/p74.webp",
  },
  closing: {
    heading: "We\u2019re creating a future worth inheriting",
    lead: "Let\u2019s make something that doesn\u2019t exist yet",
    body: "Artists, thinkers, founders and collaborators interested in developing bold new work.",
    cta: { label: "Let\u2019s play", to: "/contact" },
    bg: "/assets/melano/photos/p66.webp",
  },
};

export const commons = {
  hero: {
    eyebrow: "Collaborators",
    title: "What do we have in common?",
    subtitle: "Let\u2019s play. Everything else is too hard.",
    bg: "https://images.pexels.com/photos/36670081/pexels-photo-36670081.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1920",
  },
  intro: "These are the questions we\u2019re drawn to. If any of them are yours too, get in touch, let\u2019s make something together.",
  themes: [
    {
      feature: true,
      category: "Human Flourishing",
      title: "A State of Divergency",
      subline: "Great Minds Think Unalike",
      paragraphs: [
        "We were told that great minds think alike. Yet the minds that move us forward think at angles we have not seen before, finding connections and possibilities others have walked past. Then we tell them: simplify. Stay on topic. You are too complicated.",
        "What happens when two, twenty, or a hundred neurodivergent people come together to imagine what comes next? What does work look like when different minds shape its pace, its purpose, and its possibilities?",
        "We keep asking how neurodivergent people will fit into the future of work. What if they are already imagining work we have not learned how to do?",
      ],
      img: "https://images.unsplash.com/photo-1518611540400-6b85a0704342?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxjb250ZW1wbGF0aXZlJTIwcG9ydHJhaXR8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzkwNTU1Njg0fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      feature: true,
      category: "Culture & Humane Potential",
      title: "Bright Lights. Lonely City.",
      subline: "The City We Loved.",
      paragraphs: [
        "We built the city that never sleeps. Now the lights are on, but something feels lost. The little shops, the coffee, the dinners, the music once drew us in. Today, so much happens online. What calls us back into the streets?",
        "Our cities feel as though they are grieving. Almost as though the buildings are crying. And when we turn away from people experiencing homelessness, we turn away from people who belong to the city too.",
        "What would it take to love the city again? To honour the land beneath its buildings, care for its people, and give us reasons to gather?",
      ],
      img: "https://images.unsplash.com/photo-1560743054-589c8451bca2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxsb25lbHklMjBjaXR5JTIwbmlnaHR8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzkwNTU1NzA3fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      feature: true,
      category: "Dance Industry",
      title: "AI, TikTok & All That Jazz",
      subline: "Dance Like Everyone\u2019s Watching.",
      paragraphs: [
        "The old advice was to dance like no one is watching. Now everyone is, and the camera never blinks. When the algorithm choreographs our attention, we have to ask who we are really moving for.",
        "The dance industry has always lived between expression and performance. AI and the feed sharpen that tension, rewarding what travels fastest rather than what is felt deepest.",
        "The question is not whether to dance for the camera. It is whether we can still find the movement that is ours, the one we would make even if the lens went dark.",
      ],
      img: "/assets/melano/gen/tribal_city_dance.png",
    },
    {
      category: "Body Image",
      title: "P.S I Love / Hate You",
      explainer: "The love letter and the hate mail we send our own bodies, beauty, appetite, shame, and who profits from the war.",
      img: "https://images.unsplash.com/photo-1612529377235-777c1ad46428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxtaXJyb3IlMjByZWZsZWN0aW9uJTIwcG9ydHJhaXR8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzkwMzI2Mjk0fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      category: "Transforming Loneliness",
      title: "Walking Alone \u2026 Together",
      subline: "Between loneliness and belonging is where the wise live",
      explainer: "How to turn loneliness into sacred solitude, and find the quiet company that belonging alone can never give.",
      img: "https://images.unsplash.com/photo-1616746484147-6d5e7607835a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxsb25lJTIwZmlndXJlJTIwc29saXR1ZGV8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzkwNDA2MTczfDA&ixlib=rb-4.1.0&q=85",
    },
    {
      category: "Purpose & Burnout",
      title: "Purpose for Sale",
      subline: "Sold to the buyer who was taught fulfilment could be bought",
      explainer: "Purpose is sold to us as the cure for everything, and no one tells you what to do when you burn out from the search itself.",
      img: "https://images.unsplash.com/photo-1543250904-db6907909639?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    },
    {
      category: "Ageing",
      title: "Artificial Irrelevance",
      subline: "Who told us we disappear when we stop being seen?",
      explainer: "Being written off by a culture addicted to the new, and the wisdom we discard when we do it.",
      img: "https://images.unsplash.com/photo-1569508926450-cd832544c4ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxlbGRlcmx5JTIwaGFuZHMlMjBwb3J0cmFpdHxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3OTAzMjYzNTJ8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      category: "Intergenerational Vision",
      title: "Welcome to the Greatest Grow on Earth",
      subline: "What if we\u2019ve got vision all wrong?",
      explainer: "The long game of vision, what we choose to plant now for the generations we will never meet.",
      img: "https://images.unsplash.com/photo-1622346258057-8735a294aaa0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxoYW5kcyUyMHNvaWwlMjBzZWVkbGluZ3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3OTAzMjYzNTJ8MA&ixlib=rb-4.1.0&q=85",
    },
  ],
  closing: {
    heading: "We\u2019re creating a future worth inheriting.",
    lead: "Let\u2019s make something that doesn\u2019t exist yet",
    body: "I\u2019m looking for artists, thinkers, founders and collaborators interested in developing bold new work.",
    cta: { label: "Let\u2019s play", to: "/contact" },
    bg: IMG.sunrise,
  },
};

export const about = {
  hero: {
    eyebrow: "About",
    title: "Melano International",
    subtitle: "Holding an ecosystem shaped by Timeless Vision.",
    bg: "/assets/melano/gen/mirrorball_moon.png",
  },
  leadImg: "https://images.unsplash.com/photo-1626525357935-e1ce08fe694d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  lead: "Melano International is the parent company of NAVA Vision\u2122, Constellating Life\u2122, Dancing Zen\u2122, and Constellate 88, a family of brands devoted to Timeless Vision, Anchoring Humanity, and a future worth inheriting.",
  blocks: [
    { year: "Founded in 2019", body: "Melano emerged from the recognition that meaning, purpose, family, and community are not always enough to hold or restore a life after profound rupture, and from the deeper limitations this revealed across the healing, leadership, and wellness spaces." },
    { year: "Timeless Vision", body: "From this came Timeless Vision: a way of seeing that holds past, present, and what is emerging at once. It remains the orientation that shapes the company and its brands." },
    { year: "The founder", body: "Founder NAVA built the work after her own season of rupture. Her practice today is devoted to family and systemic constellations, and to the phenomenological practices that inform the field, grounded in leadership, coaching, and travel-led quests across Portugal, New Zealand, the United States, Australia, Spain, Italy, and the United Kingdom." },
    { year: "Today", body: "The work is devoted to constellations and the ecosystem of brands that carry Timeless Vision into rooms, retreats, organisations, and communities around the world." },
  ],
  enquiries: "Melano International receives enquiries related to the wider ecosystem, including partnerships, collaborations, media, speaking, and strategic conversations.",
};

export const contact = {
  eyebrow: "Contact",
  title: "Contact us",
  subtitle: "Send us a message and we will respond in due course.",
  bg: IMG.ritual,
  email: "weseeyou@melanointernational.com",
  emailAlt: "nava@nava.vision",
  phone: "+1 (323) 990-8000",
  phoneHref: "tel:13239908000",
  address: "Melano International Pty. Ltd.",
};

export const legal = {
  "privacy-policy": {
    title: "Privacy Policy",
    updated: "Last updated: 2025",
    sections: [
      { heading: "Privacy Statement", body: ["Melano International Pty. Ltd. and our brands, NAVA Vision, Collective Constellations, and Dancing Zen, respect your privacy and are committed to protecting your personal information in line with the Privacy Act 1988 (Cth), the Australian Privacy Principles, and applicable international privacy laws, including the EU General Data Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA). We apply these standards regardless of where you are located."] },
      { heading: "What we collect", body: ["We may collect personal information such as your name, contact details, and any information you choose to share with us through bookings, events, programs, or online forms.", "If relevant to the services you engage in, we may also collect sensitive information (for example, health information), but only with your consent and only when it is necessary to deliver our services."] },
      { heading: "How we use your information", list: ["Provide services, programs, or events you have requested", "Communicate with you about your bookings, enquiries, or relevant updates", "Maintain records for administration, compliance, and service quality", "Improve our offerings and client experience"], body: ["We do not sell or rent your information. We may share it with trusted third-party providers who assist us in delivering our services, provided they protect your information in accordance with relevant privacy laws."] },
      { heading: "Confidentiality and exceptions", body: ["All personal information you share with us is treated as confidential. We will not disclose it without your consent, except where required by law, where there is a serious risk to safety, or where disclosure is otherwise authorised by law. In these cases, we limit disclosure to what is reasonably necessary."] },
      { heading: "Security", body: ["We take reasonable steps to keep your information secure from misuse, loss, and unauthorised access. Sensitive information is stored securely and only accessed by authorised personnel."] },
      { heading: "Your rights", body: ["Depending on your location, you may have rights under local privacy laws (including GDPR and CCPA) to access, correct, delete, or restrict the processing of your personal information. Contact us to exercise these rights and we will respond in line with applicable laws."] },
      { heading: "Contact", body: ["If you have any questions or concerns about your privacy, please contact weseeyou@melanointernational.com."] },
    ],
  },
  "terms-and-conditions": {
    title: "Terms & Conditions",
    updated: "Last updated: 2025",
    sections: [
      { heading: "Agreement", body: ["These terms govern your access to and use of the Melano International website and the services offered by Melano International Pty. Ltd. and its brands. By using this website you agree to these terms."] },
      { heading: "Use of the site", body: ["You may use this website for lawful, personal, and informational purposes. You agree not to misuse the site, interfere with its operation, or attempt to access it in any unauthorised way."] },
      { heading: "Intellectual property", body: ["All content, branding, logos, and materials on this website are owned by or licensed to Melano International and may not be reproduced without prior written permission."] },
      { heading: "Bookings and services", body: ["Where services, events, or programs are offered, additional terms may apply and will be provided to you at the time of engagement. Fees, cancellation, and rescheduling terms are set out in those arrangements."] },
      { heading: "Limitation of liability", body: ["The website and its content are provided on an \u2018as is\u2019 basis. To the extent permitted by law, Melano International is not liable for any loss arising from your use of the site or reliance on its content."] },
      { heading: "Contact", body: ["Questions about these terms can be directed to weseeyou@melanointernational.com."] },
    ],
  },
  "disclaimer": {
    title: "Disclaimer",
    updated: "Last updated: 2025",
    sections: [
      { heading: "General information", body: ["The information on this website is provided for general informational purposes only. It does not constitute medical, psychological, legal, financial, or professional advice, and should not be relied upon as a substitute for advice from a qualified professional."] },
      { heading: "No therapeutic relationship", body: ["Engagement with our content, events, or brands does not create a clinical or therapeutic relationship. Systemic and constellational practices are offered as reflective and developmental work, not as treatment for any medical or psychological condition."] },
      { heading: "External links", body: ["This website may link to external websites operated by our brands or third parties. We are not responsible for the content, accuracy, or practices of those external sites."] },
      { heading: "Your responsibility", body: ["You are responsible for your own decisions and wellbeing. If you are experiencing distress or a health concern, please seek support from an appropriate qualified professional or emergency service."] },
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    updated: "Last updated: 2025",
    sections: [
      { heading: "What are cookies", body: ["Cookies are small text files placed on your device when you visit a website. They help the site function, remember preferences, and understand how it is used."] },
      { heading: "How we use cookies", list: ["Essential cookies that enable core site functionality", "Preference cookies that remember your choices", "Analytics cookies that help us understand and improve the experience"], body: ["We use cookies to keep the site working smoothly and to improve it over time."] },
      { heading: "Managing cookies", body: ["You can control and delete cookies through your browser settings. Disabling some cookies may affect how parts of the site function."] },
      { heading: "Contact", body: ["For questions about our use of cookies, contact weseeyou@melanointernational.com."] },
    ],
  },
};

export const legalNav = [
  { label: "Privacy Policy", slug: "privacy-policy" },
  { label: "Terms & Conditions", slug: "terms-and-conditions" },
  { label: "Disclaimer", slug: "disclaimer" },
  { label: "Cookie Policy", slug: "cookie-policy" },
];
